import React, { useState } from "react";
import CommonTable from "components/ReactTable/Table";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
  CardFooter,
  Badge,
} from "reactstrap";
import RightPanelCard from "components/Common/RightPanelCard";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {
  fixedWidthCustomStyle,
  MASTER_STATUS_OPTIONS,
} from "components/Common/constants";
import Select, { components } from "react-select";
import { showAlert } from "components/Common/commonFunctions";

const dataTable = [
  { brand: "Fofett", status: "Active" },
  { brand: "BlendPro", status: "Inactive" },
  { brand: "CoolMax", status: "Active" },
  { brand: "BakeMaster", status: "Active" },
  { brand: "WashTech", status: "Active" },
  { brand: "CafeKing", status: "Inactive" },
  { brand: "HeatWave", status: "Inactive" },
  { brand: "ToastMate", status: "Inactive" },
  { brand: "QuickHeat", status: "Active" },
  { brand: "MixPro", status: "Active" },
  { brand: "ChefEase", status: "Active" },
  { brand: "FreshSqueeze", status: "Active" },
  { brand: "GrillTech", status: "Active" },
  { brand: "CrispyChef", status: "Active" },
  { brand: "RiceMaster", status: "Active" },
  { brand: "StewEase", status: "Active" },
  { brand: "HeatQuick", status: "Active" },
  { brand: "SweetBake", status: "Inactive" },
  { brand: "MixIt", status: "Active" },
  { brand: "BoilMax", status: "Active" },
  { brand: "CookMaster", status: "Active" },
  { brand: "SnackEase", status: "Active" },
  { brand: "ChopMate", status: "Active" },
  { brand: "FunSnacks", status: "Active" },
  { brand: "BakeHouse", status: "Active" },
  { brand: "FryKing", status: "Inactive" },
  { brand: "PressEase", status: "Active" },
  { brand: "FlatCook", status: "Active" },
  { brand: "CoolBox", status: "Active" },
  { brand: "ChillMax", status: "Active" },
];

const BrandMaster = () => {
  const [alert, setAlert] = React.useState(null);
  const [addUserModal, setAddUserModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const columns = [
    { Header: "Brand Name", accessor: "name" },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge color={value === "Active" ? "success" : "warning"} pill>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      disableSortBy: true,
      className: "text-center",
      Cell: ({ row }) => (
        <div className="actions-right d-flex justify-content-center">
          {/* Edit */}
          <Button
            onClick={() => toggleEditUserModal(row.original)}
            color="link"
            size="sm"
            className="btn-icon btn-neutral ml-1 icon-info"
            title="Edit Brand"
          >
            <i className="tim-icons icon-pencil tim-md" />
          </Button>
          {/* Activate/Deactivate */}
          <Button
            onClick={() => handleStatusToggle(row.original)}
            color="link"
            size="sm"
            className="btn-icon btn-neutral ml-1"
            title={row.original.status === "Active" ? "Deactivate" : "Activate"}
          >
            <>
              {row.original.status === "Active" ? (
                <i className="fa fa-xmark custom-icon btn-icon icon-danger" />
              ) : (
                <i className="fa fa-check custom-icon btn-icon icon-success" />
              )}
            </>
          </Button>
        </div>
      ),
    },
  ];

  const [data, setData] = useState(
    dataTable.map((prop, key) => {
      const userObj = {
        id: key,
        name: prop.brand,
        status: prop.status,
      };
      return userObj;
    })
  );

  const [formData, setFormData] = useState({
    brandName: "",
    status: "Active", // Default to Active
  });

  const toggleAddUserModal = () => {
    setAddUserModal(!addUserModal);
    setFormData({
      brandName: "",
      status: "Active", // Reset to Active when opening add modal
    });
  };

  function toggleEditUserModal(user) {
    if (user) {
      setEditingUser(user);
      setFormData({
        brandName: user.name, // Use name instead of brandName
        status: user.status,
      });
    }
    setEditUserModal(!editUserModal);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();

    const newUser = {
      id: data.length,
      name: formData.brandName,
      status: formData.status,
    };

    setData((prevData) => [...prevData, newUser]);
    toggleAddUserModal();
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    const updatedData = data.map((user) =>
      user.id === editingUser.id
        ? {
          ...user,
          name: formData.brandName,
          status: formData.status,
        }
        : user
    );

    setData(updatedData);
    toggleEditUserModal();
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const handleStatusToggle = (data) => {
    const isActive = data.status === "Active";
    showAlert({
      title: `Are you sure you want to ${isActive ? "inactivate" : "activate"
        } this brand?`,
      message: `Brand "${data.name}" will become ${isActive ? "inactive" : "active"
        }.`,
      type: "warning",
      confirmStyle: "default",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => { },
      onCancel: () => { },
    });
  };

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={props.data.value === "ACTIVE" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={props.data.value === "ACTIVE" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  return (
    <>
      <Container fluid className="content mt-4">
        {alert}
        <Row>
          <Col md="12">
            <Card className="card-user">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <CardTitle tag="h3" className="font-weight-normal">
                  Brands
                </CardTitle>
                <Button
                  color="default"
                  onClick={toggleAddUserModal}
                  className="btn-round btn-style"
                >
                  <i className="fa fa-plus mr-1" /> Add Brand
                </Button>
              </CardHeader>

              <CardBody>
                <div className="d-flex align-items-center justify-content-between flex-wrap flex-column flex-md-row">
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    <Input
                      type="text"
                      placeholder="Search by Brand Name"
                      className="mr-2 mb-2 filter-input-large"
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={MASTER_STATUS_OPTIONS}
                      placeholder="Status"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                    />

                    <Button
                      color="default"
                      className="d-flex align-items-center mb-3 filter-btn btn-simple"
                    >
                      <i className="fa fa-search mr-1" />
                      Search
                    </Button>
                  </div>
                </div>
                <div className="mt-2 mb-3 mx-1">
                  <span className="font-weight-bold">
                    Total Brands: {dataTable.length}
                  </span>
                </div>
                <div className="table-responsive">
                  <CommonTable
                    data={data}
                    resizable={false}
                    columns={columns}
                    defaultPageSize={25}
                    showPaginationBottom={true}
                    className="-striped -highlight table-hover"
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Add Brand Modal */}
        <RightPanelCard
          isOpen={addUserModal}
          toggle={toggleAddUserModal}
          className="modal-lg"
        >
          <Card className="mb-0">
            <CardHeader toggle={toggleAddUserModal}>
              <CardTitle tag="h4" className="mb-0">
                Add Brand
              </CardTitle>
            </CardHeader>

            <Form onSubmit={handleAddSubmit}>
              <CardBody>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label for="brandName">Brand Name</Label>
                      <Input
                        id="brandName"
                        name="brandName"
                        type="text"
                        placeholder="Enter Brand name"
                        value={formData.brandName}
                        onChange={handleInputChange}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="status">Status</Label>
                      <div className="radio-rapper">
                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="status"
                              value="Active"
                              color="info"
                              checked={formData.status === "Active"}
                              onChange={handleInputChange}
                            />{" "}
                            Active
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="status"
                              value="Inactive"
                              checked={formData.status === "Inactive"}
                              onChange={handleInputChange}
                            />{" "}
                            Inactive
                          </Label>
                        </FormGroup>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter className="d-flex justify-content-end">
                <Button
                  color="secondary"
                  onClick={toggleAddUserModal}
                  className="mr-2"
                >
                  Cancel
                </Button>
                <Button color="default" type="submit">
                  Save {/* Add Brand */}
                </Button>
              </CardFooter>
            </Form>
          </Card>
        </RightPanelCard>

        {/* Edit Brand Modal */}
        <RightPanelCard
          isOpen={editUserModal}
          toggle={() => toggleEditUserModal()}
          className="modal-lg"
        >
          <Card className="mb-0">
            <CardHeader toggle={() => toggleEditUserModal()}>
              <CardTitle tag="h4" className="mb-0">
                Edit Brand
              </CardTitle>
            </CardHeader>
            <Form onSubmit={handleEditSubmit}>
              <CardBody>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label for="editbrandName">Brand Name</Label>
                      <Input
                        id="editbrandName"
                        name="brandName"
                        type="text"
                        placeholder="Enter brand name"
                        value={formData.brandName}
                        onChange={handleInputChange}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="">
                    <FormGroup>
                      <Label for="status">Status</Label>
                      <div className="radio-rapper">
                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="status"
                              value="Active"
                              checked={formData.status === "Active"}
                              onChange={handleInputChange}
                            />{" "}
                            Active
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <div className="form-check-product">
                            <Input
                              type="radio"
                              name="status"
                              value="Inactive"
                              checked={formData.status === "Inactive"}
                              onChange={handleInputChange}
                            />{" "}
                            <Label for="statusInactive">Inactive</Label>
                          </div>
                        </FormGroup>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter className="d-flex justify-content-end">
                <Button color="secondary" onClick={() => toggleEditUserModal()}>
                  Cancel
                </Button>
                <Button color="default" type="submit">
                  Update Brand
                </Button>
              </CardFooter>
            </Form>
          </Card>
        </RightPanelCard>
      </Container>
    </>
  );
};

export default BrandMaster;
